/* eslint-disable @typescript-eslint/no-explicit-any */
import styled from 'styled-components';
import {
  background,
  border,
  color,
  flexbox,
  grid,
  layout,
  position,
  shadow,
  space,
  typography,
  compose,
} from 'styled-system';

import { createSystemPropFilter } from '@utils/styled-component-tools.ts';

export interface BoxProps {
  'data-testid'?: string;
  [key: string]: any;
}

const system = compose(background, border, color, flexbox, grid, layout, position, shadow, space, typography);

const Box = styled('div')
  .withConfig({ shouldForwardProp: createSystemPropFilter(system) })
  .attrs<BoxProps>(({ 'data-testid': dataTestId = 'Box' }) => ({
    'data-testid': dataTestId,
  }))`
  box-sizing: border-box;
  min-width: 0;
  ${system};
`;
Box.displayName = 'Box';

export default Box;
